module.exports = __webpack_public_path__ + "img/slider (6).9d224c39.png";